(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/tips-info.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/tips-info.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.TipsInfo = Marionette.View.extend({
    modelEvents: {
      change: 'render'
    },

    className: 'view-tips-info tips-info',

    template: function(data) {
      return svs.matchen.templates.tips_info(data);
    },

    events: {
      'click .js-btn-papers': 'onChangeSvenskaFolket',
      'click .js-btn-curve': 'onChangeTrendGoalAvg'
    },

    initialize: function() {
      var jsonModel = this.model.toJSON();
      this.viewModel = {
        goalAvgTrend: jsonModel.goalAvgTrend.active,
        svenskaFolket: jsonModel.svenskaFolket.active
      };
    },

    onChangeTrendGoalAvg: function(event) {
      this.viewModel.goalAvgTrend = event.currentTarget.checked;
    },

    onChangeSvenskaFolket: function(event) {
      this.viewModel.svenskaFolket = event.currentTarget.checked;
    },

    onClose: function() {
      if (!this.isDestroyed()) {
        this.destroy();
      }
    }
  });
})(Backbone, _, svs);


 })(window);